import React, { useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import LabelController from "../../../atoms/Label/LabelController";
import LabelInsideInputController from "../../../atoms/InputController/LabelInside/Label-Insdie-Input-Controller/LabelInsideInputController";
import LabelInsideSelectController from "../../../atoms/InputController/LabelInside/Label-Inside-Select-Controller/LabelInsideSelectController";

export const TypeSection = ({ ...props }) => {
  const { businessType, noOfEmployees, revenue } = props.newLeadContent;
  const { errors, touched, inputValue } = props;

  const businessTypeOptions = useMemo(
    () => [
      { value: "", label: "Please Select", isDisabled: true },
      { value: "Small", label: "Small" },
      { value: "Medium", label: "Medium" },
      { value: "Large", label: "Large" },
    ],
    []
  );

  return (
    <div className="box-container">
      <Row>
        <LabelController label={businessType.label} />
        <Col sm={6}>
          <LabelInsideInputController
            touched={touched}
            value={inputValue[noOfEmployees.name]}
            name={noOfEmployees.name}
            placeholder={noOfEmployees.name}
            type={noOfEmployees.type}
            onChange={props.onChange}
            label={noOfEmployees.inputLabel}
            errors={errors}
            optional={true}
          />
          <LabelInsideSelectController
            touched={touched}
            value={inputValue[businessType.name]}
            name={businessType.name}
            placeholder="Select a business type"
            options={businessTypeOptions}
            label={businessType.inputLabel}
            errors={errors}
            onChange={props.onChange}
            inputValue={undefined}
            queryName={""}
            handleCustomerValues={props.handleBusinessType}
          />
        </Col>
        <Col sm={6}>
          <LabelInsideInputController
            touched={touched}
            value={inputValue[revenue.name]}
            name={revenue.name}
            placeholder={revenue.name}
            type={revenue.type}
            onChange={props.onChange}
            label={revenue.inputLabel}
            errors={errors}
            optional
          />
        </Col>
      </Row>
    </div>
  );
};
